<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="false"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <h5>直接会員照会</h5>
    <div class="w100 mb-4 pb-3 border-bottom">
      <div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">ライセンスNo</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="search_license_no"
                class="form-control"
              />
              <button
                @click="search_member_license_no()"
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                ライセンスNoから検索
              </button>
            </div>
          </div>
          <div class="col-3 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_member_obj.name_label"
              class="form-control"
              placeholder="会員名"
              disabled="true"
            />
          </div>
          <div
            class="col-2 mb-2"
            v-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'string' &&
              search_member_obj.id > 0
            "
          >
            <bs-button
              :btnWrapClass="'d-grid'"
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="handlePaymentSetting(search_member_obj.id)"
              >決済設定</bs-button
            >&nbsp;
          </div>
          <div
            class="col-2 mb-2"
            v-else-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'undefined'
            "
          >
            --
          </div>
        </div>
      </div>
    </div>
    <h5>検索一覧からの照会</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">年度</p>
          </div>
          <div class="col-2 mb-2">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.last_sports_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-1 mb-2">
            <p class="text-center py-1 fs-5">最終年度</p>
          </div>
          <div class="col-2 mb-2">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.sports_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">氏名/カナ</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">姓</span>
              <input
                type="text"
                v-model="sprm.like_name_1"
                class="form-control"
                placeholder="姓"
              />
              <span class="input-group-text">名</span>
              <input
                type="text"
                v-model="sprm.like_name_2"
                class="form-control"
                placeholder="名"
              />
            </div>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">セイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_1"
                class="form-control"
                placeholder="セイ"
              />
              <span class="input-group-text">メイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_2"
                class="form-control"
                placeholder="メイ"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">生年月日</p>
          </div>
          <div class="col-6 mb-2">
            <div class="input-group">
              <bs-select
                :options="birth_date_year_list"
                v-model="sprm.birth_date_year"
                :null-option="false"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">年</span>
              <bs-select
                :options="birth_date_month_list"
                v-model="sprm.birth_date_month"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">月</span>
              <bs-select
                :options="
                  birth_date_day_list(
                    sprm.birth_date_year,
                    sprm.birth_date_month
                  )
                "
                v-model="sprm.birth_date_day"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">日</span>
            </div>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <input
                type="text"
                :value="get_wareki(sprm.birth_date)"
                class="form-control-plaintext"
                placeholder=""
                readonly="true"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">表示件数</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="get_page_num_list"
              v-model="page_limit"
              :null-option="true"
              id="MainClinicId"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button :btnClass="'btn-primary'" @to_click_event="search_member"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="
        typeof member_list === 'object' && Object.keys(member_list).length > 0
      "
    >
      <table class="table mb-4">
        <thead>
          <tr>
            <th>ライセンスNo</th>
            <th>会員名(カナ)</th>
            <th>都道府県</th>
            <th>生年月日</th>
            <th>最終更新年度</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in member_list" :key="list.id">
            <td>{{ list.license_no }}</td>
            <td>{{ list.name_label }}({{ list.yomi_label }})</td>
            <td>{{ list.pref_label }}</td>
            <td>{{ list.birth_date_label }}</td>
            <td>{{ list.last_sports_year }}</td>
            <td>
              <bs-button
                :btnClass="'btn-primary btn-sm'"
                @to_click_event="handlePaymentSetting(list.id)"
                >決済設定</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <bs-page-nav
            :pager_key="'payment_setting'"
            :debug="true"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">該当する会員データはありません</p>
    </div>
  </div>
</template>
<style>
.btn_order {
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import Common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'
import moment from 'moment'

export default {
  name: 'PaymentSettingListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '決済設定',
      fromParentBtn: '',
      member_obj: [],
      search_license_no: '',
      search_member_obj: {},
      sprm: {
        license_no: '',
        like_name: '',
        like_name_1: '',
        like_name_2: '',
        like_yomi_1: '',
        like_yomi_2: '',
        last_sports_year: '',
        sports_year: '',
        search_words: '',
        pref_cd: [],
        birth_date: '',
        birth_date_year: '',
        birth_date_month: '',
        birth_date_day: ''
      },
      page: 0,
      page_limit: 10,
      page_sort: 'ASC',
      page_order: 'mfj_member_data.license_no',
      term_year_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    get_term_year: function () {
      return typeof this.term_year_obj === 'object' &&
        typeof this.term_year_obj[0] === 'object' &&
        this.term_year_obj[0]['label']
        ? parseInt(this.term_year_obj[0]['label'])
        : parseInt(Common.getNowYear())
    },
    ...mapState({}),
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    year_list: function () {
      let now = parseInt(Common.getNowYear()) + 1
      let limit = now - 7
      const tmps = []
      for (let i = now; i > limit; i--) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    birth_date_year_list: function () {
      let now = 1920
      let limit = parseInt(Common.getNowYear()) + 1
      const tmps = []
      for (let i = now; i < 1970; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      tmps.push({
        key: '',
        label: '選択して下さい'
      })
      for (let i = 1970; i < limit; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_month_list: function () {
      const tmps = []
      for (let i = 1; i <= 12; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_day_list: function () {
      const moment_func = moment
      return function (year, month) {
        let max = 31
        if (year != '' && month != '') {
          const moment = moment_func([year, parseInt(month) - 1, 1])
          max = moment.daysInMonth()
        }
        const tmps = []
        for (let i = 1; i <= max; i++) {
          tmps.push({
            key: i,
            label: i
          })
        }
        return tmps
      }
    },
    member_list: function () {
      const lists = [...this.member_obj]
      return lists
    },
    get_page_num_list: function () {
      return [
        { key: 10, label: '10件' },
        { key: 20, label: '20件' },
        { key: 50, label: '50件' },
        { key: 100, label: '100件' }
      ]
    }
  },

  async created() {
    await this.loadTermYear()
    await this.loadSearchParam()
    await this.loadMemberList(false)
  },
  mounted: function () {
    this.alertMessage = '決済設定のため、対象会員を検索してください。'
  },

  methods: {
    async search_member_license_no() {
      console.log(
        'search_license_no',
        this.search_license_no,
        typeof this.search_license_no
      )
      if (this.search_license_no.length == 6) {
        await this.loadMemberList(this.search_license_no)
      }
    },
    async search_member() {
      this.page = 0
      await this.loadMemberList(false)
    },
    async loadSearchParam() {
      const params = {
        ...this.$store.getters.getSearchParam('payment_setting')
      }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },
    handlePaymentSetting(memberId) {
      // 決済設定画面へ遷移
      this.$router.push({ path: `/payment_setting/${memberId}` })
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'payment_setting'
      })
    },
    async pageAction(page) {
      this.page = page
      await this.loadMemberList(false)
    },
    async loadMemberList(flg) {
      const params = {}
      params['stat'] = [1]

      let post_url = config.BASE_API_URL
      if (flg !== false) {
        // post_url += '/member/lists'
        post_url += '/member/number_search'
        params['license_no'] = flg
        // params['pagegroup'] = 'mfj_member_data.id'
      } else {
        post_url += '/member/lists'
        if (typeof this.sprm === 'object') {
          Object.keys(this.sprm).forEach(sprm_key => {
            if (this.sprm[sprm_key] != '') {
              params[sprm_key] = this.sprm[sprm_key]
            }
          })
        }
        params['pagelimit'] = this.page_limit
        if (this.page >= 0) params['p'] = this.page
        params['pagegroup'] = 'mfj_member_data.id'
        params['pageorder'] = this.page_order
        params['pagesort'] = this.page_sort
        this.$store.dispatch('setSearchParam', {
          data: params,
          target: 'payment_setting'
        })
      }
      console.log('loadMemberList flg', flg)
      console.log('loadMemberList sprm', this.sprm)
      console.log('loadMemberList params', params)

      await this.basicPosts_S(post_url, params)
        .then(async response => {
          if (flg !== false) {
            console.log('loadMemberList response', response)
            const tmp_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            let name_label = ''
            console.log('loadMemberList response tmp_obj', tmp_obj)
            if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
            if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
            if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
            tmp_obj.name_label = name_label
            console.log('loadMemberList response tmp_obj', tmp_obj)
            this.search_member_obj = tmp_obj
          } else {
            console.log('loadMemberList response', response)
            this.member_obj =
              response.data && response.data.body ? response.data.body : []
            this.$store.dispatch('setSearchParam', {
              data: params,
              target: 'payment_setting'
            })
            const setPageData = {}
            setPageData.data =
              response.data && response.data.pager ? response.data.pager : {}
            setPageData.target = 'payment_setting'
            console.log('loadMemberList setPageData', setPageData)
            this.$store.dispatch('setPager', setPageData)
          }
        })
        .catch(async err => {
          console.log(err)
          if (!flg) this.member_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadTermYear() {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/term_year/lists', params)
        .then(async response => {
          console.log('loadTermYear response', response)
          this.term_year_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.term_year_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    is_json(str) {
      try {
        const obj = JSON.parse(str)
        return typeof obj === 'object' && obj !== null
      } catch (e) {
        return false
      }
    }
  },
  watch: {
    search_license_no: function (new_data, old_data) {
      if (new_data.length >= 6) {
        this.search_member_license_no()
      }
    }
  }
}
</script>
